<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Beden</label>
            <v-validator :errors="errors" parameter="SizeInformationId" :watch="info">
                <v-select-list v-model="info" label="Name" placeholder="Beden" :options="infos"/>
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Değer</label>
            <v-validator :errors="errors" parameter="Value" :watch="value.Value">
                <input type="text" class="form-control" placeholder="Değer" v-model="value.Value">
            </v-validator>
        </div>
    </div>
</template>

<script>
import HumanResourcesParameterApi from '@/api/human-resources-parameters';
export default {
    props:{
        value:Object,
        errors:Object
    },
    mounted(){
        this.getSizeInformations();
    },
    data(){
        return{
            infos:[],
        }
    },
    methods:{
        getSizeInformations(){
            HumanResourcesParameterApi.SizeInformation.List().then(res=>{
                this.infos = res.data.Data
            })
        },
    },
    computed:{
        info:{
            get:function(){
                return this.infos.find(b=>b.Id==this.value.SizeInformationId)
            },
            set:function(value){
                this.value.SizeInformationId = value?.Id || null
            }
        }
    }
}
</script>
